<template>
<div>
  <div>
    <label>Agency Pre-Fill Settings</label>
    </div>
    <div class="mb-1 smaller-font-content">This paid service enables this agency to pre-fill data in each product flow</div>
    <!-- <b-form-checkbox v-model="checked" name="check-button" switch>
        Switch Checkbox <b>(Checked: {{ checked }})</b>
    </b-form-checkbox> -->
    <b-form-checkbox-group
        v-model="preFillselected"
        :options="product"
        switches
      stacked>
    </b-form-checkbox-group>

    <b-form-checkbox v-if='this.productFlag' style="margin-left: .75rem" id="homecheckbox"  name="homecheckbox"  v-model="isHomeReplacement"
      @change="homeReplacement($event)"  :disabled="this.product[0].disabled">
      Include Home Replacement Cost
    </b-form-checkbox>
    </div>
</template>
<script>
/* eslint-disable */
export default {
  props: ['product','prefillConfig','preFillselectData'],
  data() {
    return {
      optionList:[],
      productFlag:false,
      isHomeReplacement:true,
     
     };
  },
  computed: {
     preFillselected: { // aka OPTIONS
      get: function () {
        return this.optionList;
      },
      set: function (value) {
        this.optionList = value;
        if(this.optionList.indexOf("HO") >=0)
         this.productFlag=true;
         else
        this.productFlag=false;
        this.preFillselectData.splice(0, 2, this.optionList);
    },
    
  },
  },
  mounted() {
   let prefillAPIData = Object.keys(this.prefillConfig);
   prefillAPIData.forEach((data) => {
    for (const [key, value] of Object.entries(this.prefillConfig[data])) {
    if(key==='active' && value==true)
      {
      this.optionList.push(data);
      }
    if(key==='replacementCost') 
    {
      this.isHomeReplacement=value
    } 
    }
   })
  },
  methods: {
    homeReplacement(event){
     this.$emit("isHomeReplacementCheck",event);
    }
  },
};
</script>

<style scoped>



</style>




// WEBPACK FOOTER //
// src/components/admin/agencies/PreFillProduct.vue?508c3190